import React, { Component,} from "react";
import {Routes, Route} from 'react-router-dom'

import SuccessController from "./controllers/SuccessController";
import IndexController from "./controllers/IndexController";
import QuotePageController from "./controllers/QuotePageController";

import './styles'
import './scripts'

class App extends Component{
    render(){
        return(
            <Routes>
                <Route rel="canonical" exact path='/' element={<IndexController/>}/>
                <Route rel="canonical" path="/create-quote" element={<QuotePageController/>}/>
                <Route path="/success" element={<SuccessController/>}/>
            </Routes>
        );
    }

    componentDidMount(){
      window.scrollTo(window.scrollX, window.scrollY + 1);    
    }
}

export default App;
